export default __webpack_public_path__ + "static/media/addScheduleWhite.14fa36bf.svg";